// Global Types
import type {
  $FullRegion,
} from 'common.data';

// Helpers
import {
  getRegionSeasonByRegionSeasonId,
  isLatestRegionSeason,
} from 'common.helpers/dist/browser';

type $GetLocalItemBasePath = (arg0: {
  basePath: '/championship' | '/regatta';
  regions: Array<$FullRegion>;
  RegionSeasonId: string;
}) => string;

export const getLocalItemBasePath: $GetLocalItemBasePath = ({
  basePath,
  regions,
  RegionSeasonId,
}) => {
  if (!isLatestRegionSeason({
    regions,
    RegionSeasonId,
  })) {
    const regionSeason = getRegionSeasonByRegionSeasonId({
      regions,
      RegionSeasonId,
    });

    return `${basePath}/${regionSeason.Name}`;
  }

  return basePath;
};

type $GetLocalItemPath = (arg0: {
  basePath: '/championship' | '/regatta';
  item: {
    id: string;
    RegionSeasonId: string;
    Slug?: null | string;
  };
  regions: Array<$FullRegion>;
}) => string;

export const getLocalItemPath: $GetLocalItemPath = ({
  basePath,
  item,
  regions,
}) => `${getLocalItemBasePath({
  basePath,
  regions,
  RegionSeasonId: item.RegionSeasonId,
})}/${item.Slug || item.id}`;
